import instance from '@/utils/instance';

// 下载APP最新版
export function getAppDownload(params) {
	return instance({
		url: `/webL_api/essential/api/appDownload/${params}`,
		method: 'get',
		responseType: 'blob'
	});
}

//获取APP最新版
export function getAppVersion() {
	return instance({
		url: `/webL_api/essential/api/appVersion`,
		method: 'post',
        data: {appType: 0, appVersion: ""}
	});
}
